import userApi from '../../../api/user';
import optionApi from '../../../api/option';

const defaultState = () => ({
	userResults: [],
	userPagination: '',
	responSukses: {},
	konfirmResponse: {},
	OptionWarehouse: [],
	OptionType: []
});

const state = defaultState();

const getters = {

};

const mutations = {

	listUser(state, data) {
		if (data.data == 'error') {
			state.userResults = data.data
		} else {
			state.userResults = data.data.map((el) => {
				if (el.user_is_active == "active") {
					el.user_is_active = true
				} else {
					el.user_is_active = false
				}
				return el
			});
		}
		state.userPagination = data.pagination;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.konfirmResponse = {}
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	listOptionWarehouse(state, data) {
		state.OptionWarehouse = data;
	},
	listOptionType(state, data) {
		state.OptionType = data;
	},
	clearDataUser(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getUser({ commit }, value) {
		userApi.getDataUser(value).then(({ data: { data } }) => {
			commit('listUser', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listUser', { data: [], pagination: {} });
		});
	},
	getUserAll({ commit }, value) {
		userApi.getDataUserAll(value).then(({ data: { data } }) => {
			commit('listUser', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listUser', { data: [], pagination: {} });
		});
	},
	getWarehouseOption({ commit }) {
		return new Promise((resolve) => {
			userApi.getOptionWarehouseAll().then(({ data: { data: { results } } }) => {
				commit('listOptionWarehouse', results);
				resolve(results)
			}).catch(() => {
				commit('listOptionWarehouse', []);
				resolve([])
			});
		})
	},
	getTypeOption({ commit }) {
		optionApi.getOptionType().then(({ data: { data: { results } } }) => {
			commit('listOptionType', results);
		}).catch(() => {
			commit('listOptionType', []);
		});
	},
	async exportUser({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		userApi.exportUser(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data user'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportUserAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await userApi.exportUserAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data user warehouse'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async add({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		commit("konfirmasiSukses", '');
		await userApi.addUser(value).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal tambah user'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async addAll({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		commit("konfirmasiSukses", '');
		await userApi.addUserAll(value).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menambah data user'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async update({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		commit("konfirmasiSukses", '');
		await userApi.updateUser(value).then( res => {
			const data = res.data;
			commit('auth/updateProfileData', value , { root: true });
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah user'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async updateAll({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		commit("konfirmasiSukses", '');
		await userApi.updateUserAll(value).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah data user'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async delete({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		commit("konfirmasiSukses", '');
		await userApi.deleteUser({ id: value }).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
			dispatch('getUser');
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus data user'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async status({ dispatch, commit }, value) {
		await userApi.statusUser(value).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah status user'
			}, { root: true });
		});
	},
	async changeImage({ dispatch, commit }, value) {
		await userApi.changeImage(value).then( res => {
			const data = res.data;
			const image = data.data.results.user_image;
			commit('auth/updateImage', image , { root: true });
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal upload image user'
			}, { root: true });
		});
	},
	async updatePassword({ dispatch, commit }, value) {
		await userApi.changePassword(value).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal ubah password user'
			}, { root: true });
		});
	},
	async updatePasswordAll({ dispatch, commit }, value) {
		await userApi.changePasswordAll(value).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah  password user'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};